module.exports = __webpack_public_path__ + "img/raising_hands.a792c55d.gif";